import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ReceivingShowAllRequestParams } from "./interface";
import { getSearchReceivingsShowAllData } from "src/api/sp";
import { getFormattedDate } from "src/utils/getDates";
import { resetStore } from "src/store/actions";
import { mapAlternateValue, isDsdOrWt } from "src/utils/genericFunctions";
import { defaultEmptyValue } from "src/config/constants/genericConstants";

export const fetchSearchShowAllReceivings = createAsyncThunk(
  "searchShowAllReceivings",
  (payload: ReceivingShowAllRequestParams) =>
    getSearchReceivingsShowAllData(payload)
);

const initialState: any = {
  data: [],
  recordsCount: 0,
  status: "idle",
  error: null
};

const searchShowAllReceivingsSlice = createSlice({
  name: "searchShowAllReceivings",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(resetStore, (state, action) => {
        return initialState;
      })
      .addCase(fetchSearchShowAllReceivings.pending, (state) => {
        state.status = "pending";
      })
      .addCase(
        fetchSearchShowAllReceivings.fulfilled,
        (state, { payload }: { payload: any }) => {
          state.status = "idle";
          if (payload?.data?.receivingList?.length) {
            state.data = payload?.data?.receivingList?.map((data: any) => {
              const returdata = {
                ...data,
                rdvcOrAppdDate: data?.receivedDate
                  ? getFormattedDate(
                      data?.receivedDate.slice(0, 10),
                      "MM/DD/YYYY"
                    )
                  : "-",
                vendorOrItems: data.vendorOrItems,
                type: mapAlternateValue(data.receivingType),
                cases: isDsdOrWt(data?.receivingType)
                  ? data?.cases
                  : defaultEmptyValue,
                margin: isDsdOrWt(data?.receivingType)
                  ? data?.margin
                  : { margin: null }
              };
              returdata.department = [...data.department];
              return returdata;
            });
            state.recordsCount = payload?.data?.recordsCount;
          } else {
            state.data = [];
            state.recordsCount = 0;
          }
        }
      )
      .addCase(fetchSearchShowAllReceivings.rejected, (state) => {
        state.status = "error";
        state.data = [];
        state.recordsCount = 0;
      });
  }
});

export const selectsShowAllReceivingsData = (state: any) =>
  state.searchShowAllReceivings.data;

export const selectReceivingsRecordCount = (state: any) =>
  state.searchShowAllReceivings.recordsCount;

export const selectReceivingsStatus = (state: any) =>
  state.searchShowAllReceivings.status;

export default searchShowAllReceivingsSlice.reducer;
